import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormField } from 'shared/DEPRECATED/components/form/layout';
import { DataCollectionRulesContext } from '../context';
import Errors from '../../shared/errors';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../../shared/header'. 'app/webpack/javascripts/gdpr/components/shared/header.js' implicitly has an 'any' type.
import { Header } from '../../shared/header';
import type { DataCollectionRuleInterface } from '../data_collection_rule';
import EmailRecipientsSelector from './email_recipients_selector';

const t = withLocalePrefix('gdpr.data_collection_rules.view.table');

type Props = {
  rule: DataCollectionRuleInterface;
  setRule: any;
};

export default function EmailRecipients({ rule, setRule }: Props) {
  const { onFieldChange, errors } = React.useContext(
    DataCollectionRulesContext
  );

  const onChange = (event: any) => {
    onFieldChange('email_recipients');
    if (event.target.checked) {
      setRule({
        ...rule,
        email_recipients: [...rule.email_recipients, event.target.value],
      });
    } else {
      setRule({
        ...rule,
        email_recipients: rule.email_recipients.filter(
          (r) => r !== event.target.value
        ),
      });
    }
  };

  return (
    <FormField error={<Errors errors={errors.email_recipients} />}>
      <Header>{t('header.recipients')}</Header>
      <EmailRecipientsSelector
        selectedEmailRecipients={rule.email_recipients}
        onChange={onChange}
      />
    </FormField>
  );
}
